// extracted by mini-css-extract-plugin
module.exports = {"container":"HousesPage_container__3VVIT","toolbar":"HousesPage_toolbar__1hRpG","addBtn":"HousesPage_addBtn__3_bJg"};